import React from "react";
import "./Services.css";
import {
  FaPlaneDeparture,
  FaTaxi,
  FaRoute,
  FaMapMarkerAlt,
  FaCarSide,
  FaBriefcase,
  FaArrowRight,
  FaTags,
  FaRoad,
} from "react-icons/fa";



const services = [
  {
    id: "01",
    title: "Pune to Lonavala Cab",
    image: "/images/keyword/4.jpg",
    icon: <FaTaxi />,
    description:
      "Book a comfortable and reliable cab from Pune to Lonavala for family trips, weekend getaways, and sightseeing with professional drivers.",
    feature1: "One Way & Round Trip",
    feature2: "Experienced Drivers",
    link: "/pune-to-lonavala-cab-service",
  },

  {
    id: "02",
    title: "Pune to Nashik Cab Service",
    image: "/images/keyword/9.jpg",
    icon: <FaCarSide />,
    description:
      "Affordable Pune to Nashik cab service for business trips, family travel, and pilgrimage journeys with clean and comfortable cars.",
    feature1: "Affordable Fare",
    feature2: "Safe & Comfortable",
    link: "/Pune-to-Nashik-Cab-Service",
  },

  {
    id: "03",
    title: "Pune to Kolhapur Cab Service",
    image: "/images/keyword/10.jpg",
    icon: <FaTags />,
    description:
      "Reliable Pune to Kolhapur cab service with well-maintained cars and professional drivers for a smooth and comfortable journey.",
    feature1: "Best Fare",
    feature2: "24×7 Booking",
    link: "/Pune-to-Kolhapur-Cab-Service",
  },

  {
    id: "04",
    title: "Pune to Bhimashankar Cab",
    image: "/images/keyword/7.jpg",
    icon: <FaPlaneDeparture />,
    description:
      "Book a convenient Pune to Bhimashankar cab for temple visits, family trips, and pilgrimage travel with experienced local drivers.",
    feature1: "Pilgrimage Travel",
    feature2: "Doorstep Pickup",
    link: "/pune-to-bhimashankar-cab-service",
  },

  {
    id: "05",
    title: "Pune to Goa Cabs",
    image: "/images/keyword/17.jpg",
    icon: <FaRoute />,
    description:
      "Travel comfortably from Pune to Goa with reliable outstation cabs, spacious cars, and experienced drivers for a stress-free journey.",
    feature1: "One Way & Round Trip",
    feature2: "Comfortable Cars",
    link: "/Pune-to-Goa-Cabs",
  },

  {
    id: "06",
    title: "Pune to Mumbai Cabs",
    image: "/images/keyword/22.jpg",
    icon: <FaRoad />,
    description:
      "Enjoy a safe and comfortable Pune to Mumbai cab journey with professional drivers, flexible pickup options, and well-maintained vehicles.",
    feature1: "Door-to-Door Pickup",
    feature2: "Safe Journey",
    link: "/pune-to-mumbai-cab-service",
  },

  {
    id: "07",
    title: "Pune Airport Cab",
    image: "/images/keyword/62.jpg",
    icon: <FaRoute />,
    description:
      "Reliable Pune Airport cab service for airport pickups and drops with timely service, comfortable cars, and professional drivers.",
    feature1: "Airport Pickup & Drop",
    feature2: "24×7 Service",
    link: "/Pune-Airport-Cab",
  },

  {
    id: "08",
    title: "Pune to Mahabaleshwar Cab",
    image: "/images/keyword/3.jpg",
    icon: <FaMapMarkerAlt />,
    description:
      "Book a comfortable Pune to Mahabaleshwar cab for family trips, weekend getaways, or business travel with professional drivers and reliable service.",
    feature1: "Long-Distance Travel",
    feature2: "Professional Drivers",
    link: "/pune-to-mahabaleshwar-cab-service",
  },

  {
    id: "09",
    title: "Pune to Ujjain Cab",
    image: "/images/keyword/48.jpg",
    icon: <FaTaxi />,
    description:
      "Travel from Pune to Ujjain by cab with comfortable vehicles and experienced drivers, ideal for family trips and pilgrimage journeys.",
    feature1: "Pilgrimage Travel",
    feature2: "One Way & Round Trip",
    link: "/Pune-to-Ujjain-Cab",
  },
];


const Services = () => {
  return (
   
   
   
   <
>
 <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          OUR SERVICES
        </h2>
      </div>
    </section>

 


   <section className="stt-services-section">

      <div className="container">

       
        <div className="row">

          {services.map((item) => (

            <div
              className="col-lg-4 col-md-6 mb-4"
              key={item.id}
            >

              <div className="stt-card">

                {/* Image */}

                <div className="stt-card-image">

                  <img
                    src={item.image}
                    alt={item.title}
                  />

                  <span className="stt-card-number">
                    {item.id}
                  </span>

                </div>

                {/* Content */}

                <div className="stt-card-content">

                  {/* <div className="stt-card-icon">
                    {item.icon}
                  </div> */}

                  <h3 className="clr">
                    {item.title}
                  </h3>

                  <p>
                    {item.description}
                  </p>

                  {/* Features */}

                  <div className="stt-features">

                    <span>
                      {item.feature1}
                    </span>

                    <span>
                      {item.feature2}
                    </span>

                  </div>

                  {/* Footer */}

                  <div className="stt-footer">

                    <a
                      href="/booking"
                      className="stt-btn"
                    >
                      Book Now

                      <FaArrowRight />

                    </a>

                  </div>

                </div>

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>
</>
  );
};

export default Services;